<template>
  <div class="BaseHistoryFile">
    <BaseModal>
      <template>
      <v-container fluid>
        <v-row v-if="restorePanel">
          <v-col cols="6" lg="6" md="6" sm="12" xs="12">
            <BaseHistoryFileDetail
                :storeDocItemId="storeDocItemId"
                :restorePanel.sync="restorePanel"
                :activeHistoryId.sync="activeHistoryId"
                :windowHeight="windowHeight"
                :wsDetail="wsDetail"
            ></BaseHistoryFileDetail>
          </v-col>
          <v-col cols="6" lg="6" md="6" sm="12" xs="12">
            <BaseHistoryFileRestore
                :storeDocItemId="storeDocItemId"
                :activeHistoryId="activeHistoryId"
                :windowHeight="windowHeight"
                :wsRestore="wsRestore"
            ></BaseHistoryFileRestore>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" lg="12" md="12" sm="12" xs="12">
            <BaseHistoryFileDetail
                :storeDocItemId="storeDocItemId"
                :restorePanel.sync="restorePanel"
                :windowHeight="windowHeight"
                :wsDetail="wsDetail"
            ></BaseHistoryFileDetail>
          </v-col>
        </v-row>
      </v-container>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";
import BaseModal from "@/components/Base/BaseModal";
import BaseHistoryFileDetail from "@/components/BaseHistoryFile/BaseHistoryFileDetail";
import BaseHistoryFileRestore from "@/components/BaseHistoryFile/BaseHistoryFileRestore";

export default {
  name: 'BaseHistoryFile',
  props: {
    'storeDocItemId': {default: null},
    'windowHeight': {default: 680},
    'wsDetail': {default: '/ws/history_file/'},
    'wsRestore': {default: '/ws/history_file_restore/'},
  },
  components: {
    BaseModal,
    BaseHistoryFileDetail,
    BaseHistoryFileRestore,
  },
  computed: {
    ...mapFields('BaseHistoryFileDetail', {'wsDetailUrl': 'wsUrl'}),
    ...mapFields('BaseHistoryFileRestore', {'wsRestoreUrl': 'wsUrl'}),
  },
  created() {
    this.wsDetailUrl = this.wsDetail
    this.wsRestoreUrl = this.wsRestore
  },
  mounted() {
    this.wsDetailUrl = this.wsDetail
    this.wsRestoreUrl = this.wsRestore
  },
  data() {
    return {
      restorePanel: false,
      activeHistoryId: null,
    }
  },
};
</script>
